import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage2";
import { Report } from "./pages/Report";
import { PrivilegeSettingToYou } from "./pages/PrivilegeSettingToYou";
import { QrCode } from "./pages/QrCode";
import { EventType } from "./pages/EventType";
import { CreateEventType } from "./pages/component/Create/CreateEventType";
import { EditEventType } from "./pages/component/Edit/EditEventType";
import { CreateQRcode } from "./pages/component/Create/CreateQRcode";
import { EditQRcode } from "./pages/component/Edit/EditQRcode";
import { Weeklypass } from "./pages/Weeklypass";
import { BannerManagement } from "./pages/BannerManagement";
import { CreateWeeklypass } from "./pages/component/Create/CreateWeeklypass";
import { CreateBanner } from "./pages/component/Create/CreateBanner";
import { EditWeeklypass } from "./pages/component/Edit/EditWeeklypass"
import { EditBanner } from "./pages/component/Edit/EditBanner";
import { TargetGroup } from "./pages/TargetGroup";
import { TargetGroupNew } from "./pages/TargetGroupNew";
import { CreateTargetGroup } from "./pages/component/Create/CreateTargetGroup";
import { EditTargetGroup } from "./pages/component/Edit/EditTargetGroup";
import { CreatePrivilegeSettingToYou } from "./pages/component/Create/CreatePrivilegeSettingToYou";
import { EditPrivilegeSettingToYou } from "./pages/component/Edit/EditPrivilegeSettingToYou";
import { SpecialCampaign } from "./pages/SpecialCampaign";
import { CreateSpecialCampaign } from "./pages/component/Create/CreateSpecialCampaign";
import { EditSpecialCampaign } from "./pages/component/Edit/EditSpecialCampaign";
import { Notification } from "./pages/Notification";
import { CreateNotification } from "./pages/component/Create/CreateNotification";
import { EditNotification } from "./pages/component/Edit/EditNotification";
import { CreateTargetPrivilege } from "./pages/component/Create/CreateTargetPrivilege";
import { TargetGroupPrivilege } from "./pages/TargetGroupPrivilege";
import { EditTargetPrivilege } from "./pages/component/Edit/EditTargetPrivilege";
import { UserPoint } from "./pages/UserPoint";
import { AddPoint } from "./pages/AddPoint"
import { UserManagement } from "./pages/UserManagement"
import { TransactionLog } from "./pages/TransactionLog"
import { EditPointUser } from "./pages/component/Edit/EditPointUser"

import { CreateLineNotification } from "./pages/component/Create/CreateLineNotification";

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {<Redirect exact from="/" to="/dashboard" />}
        <ContentRoute path="/Dashboard" component={DashboardPage} />
        <ContentRoute path="/Report" component={Report} />
        <ContentRoute path="/PrivilegeSettingToYou" component={PrivilegeSettingToYou} />
        <ContentRoute path="/QrCode" component={QrCode} />
        <ContentRoute path="/EventType" component={EventType} />
        <ContentRoute path="/CreateEventType" component={CreateEventType} />
        <ContentRoute path="/EditEventType" component={EditEventType} />
        <ContentRoute path="/CreateQRcode" component={CreateQRcode} />
        <ContentRoute path="/EditQRcode" component={EditQRcode} />
        <ContentRoute path="/Weeklypass" component={Weeklypass} />
        <ContentRoute path="/BannerManagement" component={BannerManagement} />
        <ContentRoute path="/CreateWeeklypass" component={CreateWeeklypass} />
        <ContentRoute path="/CreateBanner" component={CreateBanner} />
        <ContentRoute path="/EditWeeklypass" component={EditWeeklypass} />
        <ContentRoute path="/EditBanner" component={EditBanner} />
        <ContentRoute path="/TargetGroup" component={TargetGroupNew} />
        <ContentRoute path="/CreateTargetGroup" component={CreateTargetGroup} />
        <ContentRoute path="/EditTargetGroup" component={EditTargetGroup} />
        <ContentRoute path="/EditTargetGroup" component={EditTargetGroup} />
        <ContentRoute path="/CreatePrivilegeSettingToYou" component={CreatePrivilegeSettingToYou} />
        <ContentRoute path="/EditPrivilegeSettingToYou" component={EditPrivilegeSettingToYou} />
        <ContentRoute path="/SpecialCampaign" component={SpecialCampaign} />
        <ContentRoute path="/CreateSpecialCampaign" component={CreateSpecialCampaign} />
        <ContentRoute path="/EditSpecialCampaign" component={EditSpecialCampaign} />
        <ContentRoute path="/Notification" component={Notification} />
        <ContentRoute path="/CreateNotification" component={CreateNotification} />
        <ContentRoute path="/EditNotification" component={EditNotification} />
        <ContentRoute path="/CreateTargetPrivilege" component={CreateTargetPrivilege} />
        <ContentRoute path="/TargetGroupPrivilege" component={TargetGroupPrivilege} />
        <ContentRoute path="/EditTargetPrivilege" component={EditTargetPrivilege} />
        <ContentRoute path="/UserPoint" component={UserPoint} />
        <ContentRoute path="/AddPoint" component={AddPoint} />
        <ContentRoute path="/UserManagement" component={UserManagement} />
        <ContentRoute path="/EditPointUser" component={EditPointUser} />
        <ContentRoute path="/TransactionLog" component={TransactionLog} />
        
        
        <ContentRoute path="/LineNotification" component={CreateLineNotification} />


        <Redirect to="/error/error-v1" />
      </Switch>
    </Suspense>
  );
}
